import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';
import { TABLE_HEADER_BG_COLOR } from '@insurancemenu/imenu-components-lib/dist/components/tables/utils/constants';

const styles = {
  inviteModal: { maxWidth: '100rem' },
  modalSubtitle: { maxWidth: '80rem' },
  modalFooter: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: '4rem',
  },
  guidelineMessage: {
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    color: colors.neutral[700],
    marginBottom: '2.4rem',
  },

  // Table Styles

  tableWrapper: {
    borderRadius: '10px',
    overflow: 'hidden',
    border: `1px solid ${colors.neutral[300]}`,
    marginBottom: '4rem',
  },
  tableBody: {
    boxSizing: 'border-box',
  },
  tableHeader: {
    boxSizing: 'border-box',
  },
  tableHeading: {
    backgroundColor: `${TABLE_HEADER_BG_COLOR}`,
    width: '7rem',
    padding: '1.6rem 1rem',
    '&:first-child': {
      paddingLeft: '2.4rem',
    },
    // Invite button cell
    '&:nth-last-child(2)': {
      width: '5rem',
    },
    // Unselect button cell
    '&:last-child': {
      width: '2rem',
    },
  },
  tableRow: {
    borderBottom: `1px solid ${colors.neutral[300]}`,
  },
  tableCell: {
    padding: '1rem',
    width: '7rem',
    '&:first-child': {
      paddingLeft: '2.4rem',
    },
    // Invite button cell
    '&:nth-last-child(2)': {
      width: '5rem',
    },
    // Unselect button cell
    '&:last-child': {
      width: '2rem',
    },
  },
  email: {
    width: '10rem',
  },
  textBtn: {
    textTransform: 'uppercase',
    fontSize: '1.4rem',
  },
  actionsBtnWrapper: {
    display: 'flex',
    justifyContent: 'center',
    '& button:first-child': {
      marginRight: '2rem',
    },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
